var App = App || {};

App.BlockFaq = (function () {
    'use strict';

    const DEFAULT_VIEW_MORE_TEXT = "View More";
    const DEFAULT_VIEW_LESS_TEXT = "View Less";

    /* =========================================================================
    State Initialization
    ========================================================================== */

    // Initializes the FAQ accordion component by ID. Prevents duplicate initialization.
    function initializeFaqAccordion(faqAccordionId) {

        const faqAccordionElement = document.getElementById(faqAccordionId);
        if (!faqAccordionElement) return;

        bindToggleButtonEvents(faqAccordionElement);
    }

    /* =========================================================================
    Event Binding
    ========================================================================== */

    // Binds each View More/View Less button to its own accordion group.
    function bindToggleButtonEvents(faqAccordionElement) {

        const accordionPanelElements = faqAccordionElement.querySelectorAll(".accordion[id]");
        if (!accordionPanelElements.length) return;

        accordionPanelElements.forEach(function (accordionPanelElement) {
            const toggleButtonElement = faqAccordionElement.querySelector(`button.faq-list__view-more[aria-controls="${accordionPanelElement.id}"]`);
            if (!toggleButtonElement) return;

            const initialExpandedState = toggleButtonElement.getAttribute("aria-expanded") === "true";
            toggleButtonElement.dataset.faqExpanded = initialExpandedState ? "true" : "false";

            syncToggleButtonLabel(toggleButtonElement);

            if (toggleButtonElement.dataset.faqToggleBound === "true") {
                return;
            }

            toggleButtonElement.addEventListener("click", function () {
                toggleFaqPanels(this, accordionPanelElement);
            });

            toggleButtonElement.dataset.faqToggleBound = "true";
        });
    }

    /* =========================================================================
    UI Synchronization
    ========================================================================== */

    // Toggles the visibility of FAQ panels and updates button state.
    function toggleFaqPanels(toggleButtonElement, accordionPanelElement) {

        const isPanelExpanded = toggleButtonElement.dataset.faqExpanded === "true";
        const nextExpandedState = !isPanelExpanded;

        toggleButtonElement.dataset.faqExpanded = nextExpandedState ? "true" : "false";
        toggleButtonElement.setAttribute("aria-expanded", nextExpandedState ? "true" : "false");
        syncToggleButtonLabel(toggleButtonElement);

        const overflowPanelElements = accordionPanelElement.querySelectorAll('.accordion-item[data-faq-overflow="true"]');

        overflowPanelElements.forEach(panel => {
            if (nextExpandedState) {
                if (panel.classList.contains("d-none")) {
                    panel.classList.remove("d-none");
                    panel.classList.add("faq-overflow-visible");
                }
                return;
            }

            if (!panel.classList.contains("faq-overflow-visible")) {
                return;
            }

            panel.classList.add("d-none");
            panel.classList.remove("faq-overflow-visible");

            const openCollapseElement = panel.querySelector(".accordion-collapse.show");
            if (openCollapseElement) {
                openCollapseElement.classList.remove("show");
            }

            const expandedButtonElement = panel.querySelector(".accordion-button:not(.collapsed)");
            if (expandedButtonElement) {
                expandedButtonElement.classList.add("collapsed");
                expandedButtonElement.setAttribute("aria-expanded", "false");
            }
        });
    }

    function syncToggleButtonLabel(toggleButtonElement) {
        const isExpanded = toggleButtonElement.dataset.faqExpanded === "true";
        const viewMoreText = toggleButtonElement.dataset.viewMoreText || DEFAULT_VIEW_MORE_TEXT;
        const viewLessText = toggleButtonElement.dataset.viewLessText || DEFAULT_VIEW_LESS_TEXT;

        toggleButtonElement.textContent = isExpanded ? viewLessText : viewMoreText;
    }

    /* ==========================================================================
    Public API Exposure
    ========================================================================== */

    return {
        initializeFaqAccordion
    };

})();